import { IonContent, IonPage } from '@ionic/react';
import { PlaceList } from '../models/factories/PlaceFactory';
import React from 'react';
import GlobalMap from '../components/MapComponents/GlobalMap';

type TestProps = {
	places: PlaceList;
};

const PlaceMap: React.FC<TestProps> = ({ places }) => {
	return (
		<IonPage>
			<IonContent fullscreen>
				<GlobalMap place_list={places} />
			</IonContent>
		</IonPage>
	);
};

export default PlaceMap;
